import clsx from "clsx";
import { StatusDerived } from "../../types";

interface StatusBadgeProps {
  status: StatusDerived;
}

export const StatusBadge = ({ status }: StatusBadgeProps) => (
  <div
    className={clsx("w-3 h-3 rounded-full", {
      "bg-amber-400": status === StatusDerived.PENDING,
      "bg-green-500": status === StatusDerived.APPROVED,
      "bg-red-500": status === StatusDerived.REJECTED,
      "bg-platform-400": status === StatusDerived.WITHDRAWN,
      "bg-blue-grey-400": status === StatusDerived.UNKNOWN,
    })}
  />
);
